import moment from 'moment'
import i18n from '../i18n'
import { getLocalStorage } from './localStorage'
import { isValidISO8601 } from './CommonMethods'

const inputDateFormats = [
  'DD/MM/YYYY',
  'YYYY-MM-DDTHH:mm:ss.SSSZ',
  'YYYY-MM-DDTHH:mm:ss.SSS',
  'DD-MM-YYYY',
  'MM/DD/YYYY',
  'MM-DD-YYYY',
  'YYYY-MM-DD',
  'YYYY/MM/DD',
]

const simpleDate = (value) => {
  const date = moment(value, inputDateFormats, true)
  if (!date.isValid()) return ''
  if (i18n.language === 'fr') {
    return date.format('DD/MM/YYYY')
  }
  if (i18n.language === 'en') {
    return date.format('MM-DD-YYYY')
  }
  return value
}

const dateAndHour = (value, notTime = false) => {
  const hasTime = isValidISO8601(value)
  const isInstanceOfDate = value instanceof Date
  const isSimpleDate = !hasTime && !isInstanceOfDate

  if (isSimpleDate) {
    return simpleDate(value)
  }
  let serverTimeZone = getLocalStorage('timezone')
  serverTimeZone = parseInt(serverTimeZone)
  if (Number.isNaN(serverTimeZone)) {
    serverTimeZone = 2
  }
  if (!moment(value).isValid(inputDateFormats, true)) return ''
  const timestamp = Date.parse(value)
  const offsetMinutes = serverTimeZone * -60
  const gmtTime = new Date(timestamp + offsetMinutes * 60000)
  const userOffset = new Date().getTimezoneOffset()
  const updatedDate = new Date(gmtTime.getTime() - userOffset * 60000)

  if (i18n.language === 'fr') {
    return moment(updatedDate).format(
      `DD/MM/YYYY   ${notTime ? '' : 'HH:mm:ss'}`
    )
  }
  if (i18n.language === 'en') {
    return moment(updatedDate).format(
      `MM-DD-YYYY   ${notTime ? '' : 'hh:mm:ss A'}`
    )
  }
  return moment(updatedDate).format(`DD/MM/YYYY   ${notTime ? '' : 'HH:mm:ss'}`)
}

const dateInput = (value, forceStandardFormat = false) => {
  const inputFormats = inputDateFormats
  let parsedDate

  if (value && value.length === 8) {
    parsedDate = moment(value, 'DDMMYYYY', true)
    if (!parsedDate.isValid()) {
      parsedDate = moment(value, 'MMDDYYYY', true)
    }
  }

  if (!parsedDate || !parsedDate.isValid()) {
    parsedDate = moment(value, inputFormats, true)
  }

  if (!parsedDate.isValid()) return ''

  if (forceStandardFormat) {
    return parsedDate.format('YYYY-MM-DD')
  }

  if (i18n.language === 'fr') {
    return parsedDate.format('DD/MM/YYYY')
  }
  if (i18n.language === 'en') {
    return parsedDate.format('MM-DD-YYYY')
  }

  return parsedDate.format()
}

const initialDate = (value, newFormat = 'YYYYMMDD') => {
  if (i18n.language === 'fr') {
    return moment(value, 'DD/MM/YYYY').format(newFormat)
  }
  if (i18n.language === 'en') {
    return moment(value, 'MM/DD/YYYY').format(newFormat)
  }
  if (moment(value).isValid()) return moment(value).format(newFormat)
  return value
}

const localDateString = (value, days = true) => {
  if (!moment(value, 'YYYY-MM-DD', false).isValid()) return value
  const event = new Date(value)
  const options = {
    weekday: days ? 'short' : undefined,
    year: '2-digit',
    month: 'short',
    day: days ? '2-digit' : undefined,
  }
  return event.toLocaleDateString(i18n.language, options)
}

const time = (value) => {
  if (!moment(value, 'HH:mm:ss').isValid()) return ''
  if (i18n.language === 'fr') {
    return moment(value, 'HH:mm:ss').format('HH:mm')
  }
  if (i18n.language === 'en') {
    return moment(value, 'HH:mm:ss').format('hh:mm A')
  }
  return moment(value, 'HH:mm:ss').format('hh:mm A')
}

const handleDateNull = (date) =>
  date !== '0000-00-00' || date !== '' || date !== null ? date : ''

export const adjustTime = (execution_time, mode = 'client') => {
  let serverTimeZone = getLocalStorage('timezone')
  serverTimeZone = parseInt(serverTimeZone)
  if (Number.isNaN(serverTimeZone)) {
    serverTimeZone = 2
  }
  const browserTimeZone = -new Date().getTimezoneOffset() / 60
  const today = new Date()
  const [hours, minutes] = execution_time.split(':').map(Number)

  const executionDate = new Date(today)

  executionDate.setHours(hours, minutes, 0, 0)

  if (mode == 'client') {
    const timezoneDifference = browserTimeZone - serverTimeZone
    executionDate.setHours(executionDate.getHours() + timezoneDifference)
  } else {
    executionDate.setHours(
      executionDate.getHours() - browserTimeZone + serverTimeZone
    )
  }
  return `${executionDate.toTimeString().split(' ')[0]}.000`
}

const dateFormat = {
  dateAndHour,
  simpleDate,
  initialDate,
  localDateString,
  time,
  handleDateNull,
  dateInput,
}
export default dateFormat
